/**
 * Generated by orval v6.23.0 🍺
 * Do not edit manually.
 * APIs for RCI FE
 * This document describes the APIs provided by NeoAP BE for RCI FE, designed to be integrated into NeoAP FE using `iframe`.\
These APIs utilize cookie-based authentication. All API requests must include the cookie `_ap_session`.

 * OpenAPI spec version: 1
 */
import {
  useInfiniteQuery,
  useQuery,
  useSuspenseInfiniteQuery,
  useSuspenseQuery,
} from '@tanstack/react-query';
import type {
  InfiniteData,
  QueryFunction,
  QueryKey,
  UseInfiniteQueryOptions,
  UseInfiniteQueryResult,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseInfiniteQueryOptions,
  UseSuspenseInfiniteQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult,
} from '@tanstack/react-query';
import type { BadRequestResponse } from '../model/badRequestResponse';
import type { ForbiddenResponse } from '../model/forbiddenResponse';
import type { GetGeneralReportsParams } from '../model/getGeneralReportsParams';
import type { GetGeneralReportsResponse } from '../model/getGeneralReportsResponse';
import type { NotFoundResponse } from '../model/notFoundResponse';
import type { UnauthorizedResponse } from '../model/unauthorizedResponse';
import type { UnprocessableEntityResponse } from '../model/unprocessableEntityResponse';
import { useCustomClient } from '../../mutator/custom-instance';
import type { ErrorType } from '../../mutator/custom-instance';
import { customFomDataFn } from '../../api/formData/custom-function';

type AwaitedInput<T> = PromiseLike<T> | T;

type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;

// eslint-disable-next-line
type SecondParameter<T extends (...args: any) => any> = T extends (
  config: any,
  args: infer P
) => any
  ? P
  : never;

/**
 * @summary Returns general reports for expenses and payables associated with the logged-in office member, limited to reports created within the last 6 months by default
 */
export const useGetGeneralReportsHook = () => {
  const getGeneralReports = useCustomClient<GetGeneralReportsResponse>();

  return (
    params?: GetGeneralReportsParams,
    options?: SecondParameter<ReturnType<typeof useCustomClient>>
  ) => {
    return getGeneralReports(
      { url: `/api/js/general_reports`, method: 'GET', params },
      options
    );
  };
};

export const getGetGeneralReportsQueryKey = (
  params?: GetGeneralReportsParams
) => {
  return [`/api/js/general_reports`, ...(params ? [params] : [])] as const;
};

export const useGetGeneralReportsInfiniteQueryOptions = <
  TData = InfiniteData<
    Awaited<ReturnType<ReturnType<typeof useGetGeneralReportsHook>>>,
    GetGeneralReportsParams['page']
  >,
  TError = ErrorType<
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | UnprocessableEntityResponse
  >
>(
  params?: GetGeneralReportsParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useGetGeneralReportsHook>>>,
        TError,
        TData,
        Awaited<ReturnType<ReturnType<typeof useGetGeneralReportsHook>>>,
        QueryKey,
        GetGeneralReportsParams['page']
      >
    >;
    request?: SecondParameter<ReturnType<typeof useCustomClient>>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetGeneralReportsQueryKey(params);

  const getGeneralReports = useGetGeneralReportsHook();

  const queryFn: QueryFunction<
    Awaited<ReturnType<ReturnType<typeof useGetGeneralReportsHook>>>,
    QueryKey,
    GetGeneralReportsParams['page']
  > = ({ pageParam }) =>
    getGeneralReports(
      { ...params, page: pageParam || params?.['page'] },
      requestOptions
    );

  return { queryKey, queryFn, ...queryOptions } as UseInfiniteQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useGetGeneralReportsHook>>>,
    TError,
    TData,
    Awaited<ReturnType<ReturnType<typeof useGetGeneralReportsHook>>>,
    QueryKey,
    GetGeneralReportsParams['page']
  > & { queryKey: QueryKey };
};

export type GetGeneralReportsInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useGetGeneralReportsHook>>>
>;
export type GetGeneralReportsInfiniteQueryError = ErrorType<
  | BadRequestResponse
  | UnauthorizedResponse
  | ForbiddenResponse
  | NotFoundResponse
  | UnprocessableEntityResponse
>;

/**
 * @summary Returns general reports for expenses and payables associated with the logged-in office member, limited to reports created within the last 6 months by default
 */
export const useGetGeneralReportsInfinite = <
  TData = InfiniteData<
    Awaited<ReturnType<ReturnType<typeof useGetGeneralReportsHook>>>,
    GetGeneralReportsParams['page']
  >,
  TError = ErrorType<
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | UnprocessableEntityResponse
  >
>(
  params?: GetGeneralReportsParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useGetGeneralReportsHook>>>,
        TError,
        TData,
        Awaited<ReturnType<ReturnType<typeof useGetGeneralReportsHook>>>,
        QueryKey,
        GetGeneralReportsParams['page']
      >
    >;
    request?: SecondParameter<ReturnType<typeof useCustomClient>>;
  }
): UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = useGetGeneralReportsInfiniteQueryOptions(
    params,
    options
  );

  const query = useInfiniteQuery(queryOptions) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const useGetGeneralReportsQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useGetGeneralReportsHook>>>,
  TError = ErrorType<
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | UnprocessableEntityResponse
  >
>(
  params?: GetGeneralReportsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useGetGeneralReportsHook>>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<ReturnType<typeof useCustomClient>>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetGeneralReportsQueryKey(params);

  const getGeneralReports = useGetGeneralReportsHook();

  const queryFn: QueryFunction<
    Awaited<ReturnType<ReturnType<typeof useGetGeneralReportsHook>>>
  > = () => getGeneralReports(params, requestOptions);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useGetGeneralReportsHook>>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetGeneralReportsQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useGetGeneralReportsHook>>>
>;
export type GetGeneralReportsQueryError = ErrorType<
  | BadRequestResponse
  | UnauthorizedResponse
  | ForbiddenResponse
  | NotFoundResponse
  | UnprocessableEntityResponse
>;

/**
 * @summary Returns general reports for expenses and payables associated with the logged-in office member, limited to reports created within the last 6 months by default
 */
export const useGetGeneralReports = <
  TData = Awaited<ReturnType<ReturnType<typeof useGetGeneralReportsHook>>>,
  TError = ErrorType<
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | UnprocessableEntityResponse
  >
>(
  params?: GetGeneralReportsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useGetGeneralReportsHook>>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<ReturnType<typeof useCustomClient>>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = useGetGeneralReportsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const useGetGeneralReportsSuspenseQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useGetGeneralReportsHook>>>,
  TError = ErrorType<
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | UnprocessableEntityResponse
  >
>(
  params?: GetGeneralReportsParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useGetGeneralReportsHook>>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<ReturnType<typeof useCustomClient>>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetGeneralReportsQueryKey(params);

  const getGeneralReports = useGetGeneralReportsHook();

  const queryFn: QueryFunction<
    Awaited<ReturnType<ReturnType<typeof useGetGeneralReportsHook>>>
  > = () => getGeneralReports(params, requestOptions);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useGetGeneralReportsHook>>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetGeneralReportsSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useGetGeneralReportsHook>>>
>;
export type GetGeneralReportsSuspenseQueryError = ErrorType<
  | BadRequestResponse
  | UnauthorizedResponse
  | ForbiddenResponse
  | NotFoundResponse
  | UnprocessableEntityResponse
>;

/**
 * @summary Returns general reports for expenses and payables associated with the logged-in office member, limited to reports created within the last 6 months by default
 */
export const useGetGeneralReportsSuspense = <
  TData = Awaited<ReturnType<ReturnType<typeof useGetGeneralReportsHook>>>,
  TError = ErrorType<
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | UnprocessableEntityResponse
  >
>(
  params?: GetGeneralReportsParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useGetGeneralReportsHook>>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<ReturnType<typeof useCustomClient>>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = useGetGeneralReportsSuspenseQueryOptions(
    params,
    options
  );

  const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const useGetGeneralReportsSuspenseInfiniteQueryOptions = <
  TData = InfiniteData<
    Awaited<ReturnType<ReturnType<typeof useGetGeneralReportsHook>>>,
    GetGeneralReportsParams['page']
  >,
  TError = ErrorType<
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | UnprocessableEntityResponse
  >
>(
  params?: GetGeneralReportsParams,
  options?: {
    query?: Partial<
      UseSuspenseInfiniteQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useGetGeneralReportsHook>>>,
        TError,
        TData,
        Awaited<ReturnType<ReturnType<typeof useGetGeneralReportsHook>>>,
        QueryKey,
        GetGeneralReportsParams['page']
      >
    >;
    request?: SecondParameter<ReturnType<typeof useCustomClient>>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetGeneralReportsQueryKey(params);

  const getGeneralReports = useGetGeneralReportsHook();

  const queryFn: QueryFunction<
    Awaited<ReturnType<ReturnType<typeof useGetGeneralReportsHook>>>,
    QueryKey,
    GetGeneralReportsParams['page']
  > = ({ pageParam }) =>
    getGeneralReports(
      { ...params, page: pageParam || params?.['page'] },
      requestOptions
    );

  return {
    queryKey,
    queryFn,
    ...queryOptions,
  } as UseSuspenseInfiniteQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useGetGeneralReportsHook>>>,
    TError,
    TData,
    Awaited<ReturnType<ReturnType<typeof useGetGeneralReportsHook>>>,
    QueryKey,
    GetGeneralReportsParams['page']
  > & { queryKey: QueryKey };
};

export type GetGeneralReportsSuspenseInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useGetGeneralReportsHook>>>
>;
export type GetGeneralReportsSuspenseInfiniteQueryError = ErrorType<
  | BadRequestResponse
  | UnauthorizedResponse
  | ForbiddenResponse
  | NotFoundResponse
  | UnprocessableEntityResponse
>;

/**
 * @summary Returns general reports for expenses and payables associated with the logged-in office member, limited to reports created within the last 6 months by default
 */
export const useGetGeneralReportsSuspenseInfinite = <
  TData = InfiniteData<
    Awaited<ReturnType<ReturnType<typeof useGetGeneralReportsHook>>>,
    GetGeneralReportsParams['page']
  >,
  TError = ErrorType<
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | UnprocessableEntityResponse
  >
>(
  params?: GetGeneralReportsParams,
  options?: {
    query?: Partial<
      UseSuspenseInfiniteQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useGetGeneralReportsHook>>>,
        TError,
        TData,
        Awaited<ReturnType<ReturnType<typeof useGetGeneralReportsHook>>>,
        QueryKey,
        GetGeneralReportsParams['page']
      >
    >;
    request?: SecondParameter<ReturnType<typeof useCustomClient>>;
  }
): UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = useGetGeneralReportsSuspenseInfiniteQueryOptions(
    params,
    options
  );

  const query = useSuspenseInfiniteQuery(
    queryOptions
  ) as UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};
